(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-status"] && !Shopify.designMode) return;
  try {
    (function () {
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function ymd(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }

    function localeFor(code) {
      var map = { en: 'en-GB', nl: 'nl-NL', de: 'de-DE', fr: 'fr-FR', es: 'es-ES', it: 'it-IT' };
      return map[code] || code || 'en-GB';
    }

    function strftime(d, format, locale) {
      var tokens = {
        '%a': function () { return d.toLocaleDateString(locale, { weekday: 'short' }).replace(/\.$/, ''); },
        '%A': function () { return d.toLocaleDateString(locale, { weekday: 'long' }); },
        '%b': function () { return d.toLocaleDateString(locale, { month: 'short' }).replace(/\.$/, ''); },
        '%B': function () { return d.toLocaleDateString(locale, { month: 'long' }); },
        '%d': function () { return pad(d.getDate()); },
        '%-d': function () { return String(d.getDate()); },
        '%e': function () { return String(d.getDate()); },
        '%m': function () { return pad(d.getMonth() + 1); },
        '%-m': function () { return String(d.getMonth() + 1); },
        '%Y': function () { return String(d.getFullYear()); },
        '%y': function () { return String(d.getFullYear()).slice(-2); }
      };
      return format.replace(/%-?[aAbBdemYy]/g, function (t) { return tokens[t] ? tokens[t]() : t; });
    }

    function compute(el) {
      var businessDays = parseInt(el.dataset.businessDays, 10) || 2;
      var cutoffHour = parseInt(el.dataset.cutoffHour, 10);
      if (isNaN(cutoffHour)) cutoffHour = 24;
      var holidays = (el.dataset.holidays || '').split(/[\s,;]+/).filter(Boolean);
      var weekend = [];
      if (el.dataset.skipSaturday === 'true') weekend.push(6);
      if (el.dataset.skipSunday === 'true') weekend.push(0);

      function isBusinessDay(d) {
        return weekend.indexOf(d.getDay()) === -1 && holidays.indexOf(ymd(d)) === -1;
      }

      var now = new Date();
      var start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      if (now.getHours() >= cutoffHour || !isBusinessDay(start)) {
        do { start.setDate(start.getDate() + 1); } while (!isBusinessDay(start));
      }
      var d = new Date(start.getTime());
      var added = 0;
      while (added < businessDays) {
        d.setDate(d.getDate() + 1);
        if (isBusinessDay(d)) added++;
      }
      return d;
    }

    function update() {
      var bars = document.querySelectorAll('[data-ship-bar]');
      for (var i = 0; i < bars.length; i++) {
        var el = bars[i];
        var target = el.querySelector('[data-ship-date]');
        if (!target) continue;
        /* Alleen bijwerken als de server-datum niet van vandaag is (cache) */
        if (el.dataset.rendered === ymd(new Date())) continue;
        var date = compute(el);
        target.textContent = strftime(date, el.dataset.format || '%a %-d %B', localeFor(el.dataset.locale));
        el.dataset.rendered = ymd(new Date());
      }
    }

    update();
    /* Horizon rendert de productsectie opnieuw bij variantwissel */
    document.addEventListener('variant:update', update);
    document.addEventListener('shopify:section:load', update);
  })();
  } catch(e) { console.error(e); }
})();

})();
